import "../../../styles/index.css"
import "./CarouselFotos.scss"
import Slider from "react-slick";
import ReactImageMagnify from 'react-image-magnify';

function CarouselFotos({ images }) {

    const settings = {
        dots: true,
        infinite: true,
        draggable: true,
        swipe: true,
        swipeToSlide: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (


        <div className={`carousel-images-container`}>
            <div className={`slider-container`}>
                <Slider {...settings}>
                    {
                        images.map((image, index) => {
                            return (
                                <div key={index} className={`carousel-item`}>
                                    {/* <img src={image} className="imgDoProduto" alt="..." /> */}

                                    <ReactImageMagnify {...{
                                        smallImage: {
                                            alt: 'Imagem do Produto',
                                            isFluidWidth: true,
                                            src: image
                                        },
                                        largeImage: {
                                            src: image,
                                            width: 1200,
                                            height: 1800
                                        },
                                        imageClassName: 'imgDoProduto',
                                        enlargedImagePosition: 'over'
                                    }} />

                                </div>
                            )
                        })
                    }
                </Slider>

            </div>
        </div>
    )
}

export default CarouselFotos
